/** Maximum simultaneous remote guests in a Live (Phase 1 target). */
export const MAX_GUESTS = 6;

/** Length of the random token embedded in a guest invite URL. */
export const GUEST_TOKEN_LENGTH = 24;

/** Alphabet used for guest tokens: unambiguous in a URL, case-sensitive. */
export const GUEST_TOKEN_ALPHABET =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

/**
 * LiveKit room names are derived from the Live id, so the mapping is
 * deterministic and needs no extra lookup on either side.
 */
export function livekitRoomName(liveId: string): string {
  return `live-${liveId}`;
}

/** How long a host's LiveKit token stays valid. */
export const HOST_TOKEN_TTL = '4h';

/** How long a guest's LiveKit token stays valid. */
export const GUEST_TOKEN_TTL = '4h';

/**
 * How long the Layout Page's token stays valid. Longer than a host's, because
 * a broadcast outliving its compositor's token would lose the programme feed
 * mid-air with nothing on screen to explain it.
 */
export const EGRESS_TOKEN_TTL = '12h';

/**
 * Track-name prefix for a media clip the host is playing into the room.
 *
 * A clip is published like any other source, which is what makes guests and
 * Egress see it for free - but it is not a person. The AUTO layer arranges
 * participants, and a rolled trailer appearing as a face in the grid is never
 * what anyone meant, so renderers recognise it by this prefix and leave it out.
 */
export const MEDIA_TRACK_PREFIX = 'media-';
